import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[130px] h-[173px]',
    medium: 'w-[160px] h-[213px]',
    large: 'w-[200px] h-[267px]',
  };

  const titleSizes = {
    small: 'text-sm',
    medium: 'text-sm',
    large: 'text-base',
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`${coverSizes[size]} relative overflow-hidden rounded-lg mb-3 bg-background-200`}>
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${comic.title} - 韩漫大全`}
        />
        {comic.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
            热门
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-[10px] font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
            新作
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-star-fill text-xs text-accent-500"></i>
            </div>
            <span className="text-xs font-semibold text-background-50">{comic.rating}</span>
          </div>
        </div>
        <span
          className={`absolute top-2 right-2 px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
            comic.status === 'completed'
              ? 'bg-accent-500/90 text-background-50'
              : 'bg-secondary-500/90 text-background-50'
          }`}
        >
          {comic.status === 'completed' ? '已完结' : '连载中'}
        </span>
      </div>
      <h3 className={`${titleSizes[size]} font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug`}>
        {comic.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
    </Link>
  );
}